<template>
    <div class="profileCard" @click="goto_applicant()">
      <div class="hero">
        <div class="map" ref="map"></div>
      </div>
      <div class="body">
        <div class="profileImg">
          <img class="clickable" :src="profileImg" @click="goto_applicant()">
        </div>

        <transition name="fade">
          <div class="body-wrapper">
            <h2 class="clickable">{{applicant.name}}</h2>
            <p class="subtext">{{applicant.address | formatAddress('applicants')}}</p>
          </div>
        </transition>
      </div>

      <transition name="fade">
      <div class="body-2">
        
          <template v-if="applicant.description">
            <p class="break">
            {{applicant.description | shorten}}
            </p>
          </template>
          <template v-else>
            <p class="subtext">Keine Beschreibung verfügbar.</p>
          </template>
          <!--
          <stb-button name="Anfrage senden"/>
          -->
      </div>
    </transition>
    </div>
</template>

<script>
import { create_map, create_marker } from '@/utils/map'
// ion-ios-search
export default {
    props: {
      applicant: {},
    },
    computed: {
      profileImg() {
        var img = this.applicant.$p.get('profile_image')
        if (!img || img === undefined || img == "" ||
          this.applicant.profile_image == null) {
          return "/static/images/bewerberIcon.svg";
        } else {
          // console.log(img.file);
          return img.file.url();
        }
      },
      showMap() {
        return this.applicant.location && this.applicant.location.lat && this.applicant.location.lng;
      },
    },
    methods: {
      goto_applicant() {
        this.$router.push('/applicants/' + this.applicant.objectId);
      },
    },

    mounted() {
      if (this.showMap) {
        var mapEl = this.$refs.map;
        var mapPos = {
          lng: this.applicant.location.lng-0.15,
          lat: this.applicant.location.lat
        } 
        var map = create_map(mapEl, mapPos, 9, null, true);
        create_marker(map, this.applicant.location);
      }
    }
}
</script>

<style lang="scss" scoped>
  .profileCard {
    max-width: 460px;
    background-color: $light-bg-color;
    @include border-radius();
    @include drop-shadow();
    overflow: hidden;
    display: inline-block;
    width: calc(50% - 1.5em);
    min-width: 300px;
    cursor: pointer;
    transition: all 0.14s ease;

    &:hover {
      transform: translateY(-5px) translateZ(0);
      @include hover();
    }

  }

  .hero {
    padding-bottom: 40%;
    background-color: $dark-grey;
    position: relative;
    display: block;
    overflow: hidden;
  }

  .hero .map {
    position: absolute;
    width: 100%;
    height: calc(100% + 25px);

  }

  .body {
    padding: 0;
    position: relative;
    /*min-height: 6em;*/
  }

  .body-wrapper {
    padding: 1em;
    padding-left: 35%;
    padding-bottom: 7%;
  }

  .body-2 {
    padding: 1em;
    padding-top: 0;
  }

  .body-2 .stb-button {
    margin-top: 0.7em;
  }

  .profileImg {
    width: calc(35% - 2em);
    position: absolute;
    padding-bottom: calc(35% - 2em);
    border-radius: 100%;
    overflow: hidden;
    @include drop-shadow();
    left: 1em;
    transform: translateY(-50%);
    background-color: $light-bg-color;

  }

  .profileImg img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .clickable {
    cursor: pointer;
  }

  @media (max-width: 670px) {
    .profileCard {
      max-width: 100%;
      width: 100%;
    }

    .body {
      padding-bottom: 10%
    }
  }
  

</style>



// WEBPACK FOOTER //
// src/components/general/profileCard.vue